export const ROLE = {
  GUEST: 'ROLE_GUEST',
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN',
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  PARTICIPANT: 'ROLE_PARTICIPANT',
  COACH: 'ROLE_COACH'
};



// WEBPACK FOOTER //
// /dist/src/app/user/roles.const.ts